<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <h3 class="headline my-3">Encuesta de Servicios</h3>
                <div v-if="cargandoDatos">
                    <v-progress-linear :indeterminate="true"></v-progress-linear>
                </div>
                <div v-else>
                    <v-stepper v-if="!encuestado" v-model="e1">
                        <v-stepper-header>
                            <template v-for="(departamento, index) in departamentos">
                                <v-stepper-step :complete="e1 > (index + 1)" :step="index + 1">{{ departamento.name }}</v-stepper-step>

                                <v-divider></v-divider>
                            </template>
                            <v-stepper-step :complete="e1 > (departamentos.length + 1)" :step="(departamentos.length + 1)">Finalizar</v-stepper-step>
                        </v-stepper-header>
                        <v-stepper-items>
                            <template v-for="(departamento, index) in departamentos">
                                <v-stepper-content :step="index + 1">
                                    <v-card flat class="mb-5">
                                        <v-card-text>
                                            <h3 class="headline mb-3">{{departamento.name}}</h3>
                                            <template v-for="(question, indexQ) in departamento.questions">
                                                <v-hover>
                                                    <v-card flat slot-scope="{ hover }" :class="`${hover ? 'grey lighten-4': ''}`">
                                                        <v-card-text class="py-0">
                                                            <v-layout row wrap>
                                                                <v-flex md6 mt-1>
                                                                    <div class="v-list__tile">{{question.text}}</div>
                                                                </v-flex>
                                                                <v-flex md6 my-2>
                                                                    <v-rating v-model="question.answer"></v-rating>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-divider v-if="$vuetify.breakpoint.xsOnly"></v-divider>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-hover>
                                            </template>
                                            <div class="px-4 mt-2">
                                                <div class="pl-1">
                                                    <div class="subheading">Tu opinión es importante, dejanos un comentario:</div>
                                                    <v-textarea  outline
                                                                 name="input-7-4"
                                                                 label="Comentario"
                                                                 v-model="departamento.comentario">
                                                    </v-textarea>
                                                </div>
                                            </div>
                                        </v-card-text>
                                    </v-card>

                                    <v-btn
                                            color="primary"
                                            @click="e1 = index + 2"
                                    >
                                        Siguiente
                                    </v-btn>

                                    <v-btn flat @click="clear">Cancelar</v-btn>
                                </v-stepper-content>
                            </template>
                            <v-stepper-content :step="departamentos.length + 1">
                                <v-card flat class="mb-5">
                                    <v-card-text>
                                        <h3 class="headline mb-3">Gracias por tus respuestas</h3>
                                        <p>Para finalizar pulsa el botón <code>guardar respuestas</code></p>
                                    </v-card-text>
                                </v-card>

                                <v-btn
                                        color="primary"
                                        @click="save"
                                >
                                    Guardar respuestas
                                </v-btn>

                                <v-btn flat @click="clear">Cancelar</v-btn>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                    <p v-else>Gracias por tus respuestas, la próxima encuesta será el siguiente semestre.</p>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'EncuestaServiciosPage',
    data: () => ({
      e1: 0,
      encuestado: true,
      cargandoDatos: true,
      departamentos: [
        {
          name: 'Centro de Información',
          abbr: 'ci',
          comentario: '',
          questions: [
            { text: 'Tiene un horario adecuado de consulta.', answer: 0 },
            { text: 'La información con la que cuenta me apoya en las asignaturas que curso.', answer: 0 },
            { text: 'Siempre encuentro por lo menos un ejemplar disponible de la bibliografía señalada en las asignaturas que curso.', answer: 0 },
            { text: 'La bibliografía de la que se dispone es actualizada.', answer: 0 },
            { text: 'Se me proporciona atención adecuada en caso de buscar determinado libro.', answer: 0 },
            { text: 'Me orientan adecuadamente para encontrar en caso de carencia, libros equivalentes al requerido.', answer: 0 },
            { text: 'Tienen disposición para atenderme cuando solicito un servicio.', answer: 0 },
            { text: 'Me atienden en forma amable cuando solicito su apoyo', answer: 0 },
            { text: 'Mantienen una relación atenta conmigo durante mi estancia', answer: 0 }
          ]
        },
        {
          name: 'Coordinación de Carreras',
          abbr: 'cc',
          comentario: '',
          questions: [
            { text: 'Tiene un horario adecuado de atención.', answer: 0 },
            { text: 'Me proporciona información necesaria para el manejo de mi retícula de carrera.', answer: 0 },
            { text: 'Me da orientación adecuada cuando requiero realizar trámites en la institución.', answer: 0 },
            { text: 'Me orienta acerca de desarrollo del plan de estudios de la carrera.', answer: 0 },
            { text: 'Me da información necesaria para realizar las Residencias Profesionales.', answer: 0 },
            { text: 'Me proporciona información sobre el proceso para la reinscripción de estudiantes.', answer: 0 },
            { text: 'Me orientan para resolver situaciones de tipo académico.', answer: 0 },
            { text: 'Me dan la orientación necesaria para la realización de trámites de titulación.', answer: 0 },
            { text: 'Me proporciona información sobre el calendario escolar.', answer: 0 }
          ]
        },
        {
          name: 'Recursos financieros',
          abbr: 'rf',
          comentario: '',
          questions: [
            { text: 'Tiene un horario adecuado para realizar mis trámites.', answer: 0 },
            { text: 'Me proporcionan una lista actualizada de los costos de los diferentes trámites.', answer: 0 },
            { text: 'El tiempo de espera para pagar en caja es aceptable.', answer: 0 },
            { text: 'El personal de Recursos Financieros atiende las peticiones que le hago.', answer: 0 },
            { text: 'El personal de Recursos Financieros siempre me cobra el concepto Correcto.', answer: 0 },
            { text: 'Me proporcionan asesoría adecuada cuando desconozco qué o cuánto pagar.', answer: 0 },
            { text: 'Me atienden en forma oportuna cuando solicito un servicio.', answer: 0 },
            { text: 'Me atienden en forma amable cuando solicito su servicio.', answer: 0 },
            { text: 'Mantienen una relación atenta conmigo durante todo el tiempo en que me otorga el servicio.', answer: 0 }
          ]
        },
        {
          name: 'Centro de computo',
          abbr: 'ccp',
          comentario: '',
          questions: [
            { text: 'El Servicio de Cómputo tiene un horario adecuado.', answer: 0 },
            { text: 'Siempre hay máquinas disponibles para realizar mi trabajo.', answer: 0 },
            { text: 'Siempre tengo disponible una conexión de Internet.', answer: 0 },
            { text: 'Me proporcionan atención adecuada en el servicio de Internet.', answer: 0 },
            { text: 'Me proporcionan atención adecuada en caso de presentarse fallas en el equipo que se me asignó.', answer: 0 },
            { text: 'Me proporcionan asesoría adecuada para resolver mis dudas sobre el uso de software.', answer: 0 },
            { text: 'Me atienden en forma oportuna cuando solicito cualquier servicio.', answer: 0 },
            { text: 'Me atienden en forma amable cuando solicito información.', answer: 0 },
            { text: 'Mantienen una relación atenta conmigo durante toda mi estancia en las instalaciones.', answer: 0 }
          ]
        },
        {
          name: 'Servicios Escolares',
          abbr: 'se',
          comentario: '',
          questions: [
            { text: 'El Departamento de Servicios Escolares tiene un horario adecuado de atención.', answer: 0 },
            { text: 'El tiempo de respuesta a mis solicitudes es rápido.', answer: 0 },
            { text: 'El tiempo de espera para ser atendido en ventanilla es adecuado.', answer: 0 },
            { text: 'Me proporcionan atención adecuada en el servicio.', answer: 0 },
            { text: 'Me proporcionan información adecuada en caso de que se la solicite.', answer: 0 },
            { text: 'Me orientan adecuadamente cuando se lo solicito.', answer: 0 },
            { text: 'Me atienden en forma oportuna cuando solicito un servicio.', answer: 0 },
            { text: 'Me atienden en forma amable cuando solicito su apoyo.', answer: 0 },
            { text: 'Mantienen una relación atenta conmigo durante toda mi estancia en el departamento.', answer: 0 }
          ]
        },
        {
          name: 'Servicio Social',
          abbr: 'ss',
          comentario: '',
          questions: [
            { text: 'La oficina de Servicio Social tiene un horario adecuado para realizar mis tramites.', answer: 0 },
            { text: 'La oficina de Servicio Social me ofrece un catalogo de instituciones en donde pueda realizarlo.', answer: 0 },
            { text: 'La oficina de Servicio Social me gestiona apoyos para desarrollar mis actividades.', answer: 0 },
            { text: 'Me proporcionan atención  adecuada cuando realizo mis tramites.', answer: 0 },
            { text: 'Me apoyan adecuadamente en la busqueda, en caso de no tener en donde hacerlo.', answer: 0 },
            { text: 'Me proporcionan asesoria para desarrollar en forma adecuada el Servicio Social.', answer: 0 },
            { text: 'Me atienden en forma inmediata al solicitar informacion.', answer: 0 },
            { text: 'Me atienden en forma amable al solicitar informacion del Servicio Social.', answer: 0 },
            { text: 'Mantienen una relacion atenta conmigo durante toda mi estancia en su oficina.', answer: 0 }
          ]
        },
        {
          name: 'Residencias Profesionales',
          abbr: 'rp',
          comentario: '',
          questions: [
            { text: 'El Departamento de Gestion Tecnologica y Vinculacion me proporciona  informacion del banco de proyectos de Residencias Profesionales.', answer: 0 },
            { text: 'La Division de Estudios Profesionales me da informacion de las Opciones para realizar los Anteproyectos de Residencias Profesionales.', answer: 0 },
            { text: 'El Coordinador de Carrera me da informacion para desarrollo de anteproyectos de Residencias Profesionales.', answer: 0 },
            { text: 'La Division de Estudios me proporciona informacion acerca de los periodos para la recepcion de anteproyectos de Residencias Profesionales.', answer: 0 },
            { text: 'El Docente Asignado para revisar mi anteproyecto de residencias dictamina en el periodo establecido.', answer: 0 },
            { text: 'Mi Asesor Interno me proporciona asesoria para el desarrollo de mi proyecto Residencias Profesionales.', answer: 0 },
            { text: 'El Departamento de Gestion Tecnologica y Vinculacion me entrega en tiempo las cartas de presentacion y agradecimiento para la empresa.', answer: 0 },
            { text: 'Mi Asesor Interno revisa mis informes parciales de Residencias Profesionales y me orienta para realizar las correcciones y cambios.', answer: 0 },
            { text: 'Mi Asesor Interno me da a conocer la calificacion durante el periodo Establecido.', answer: 0 }
          ]
        },
        {
          name: 'Actividades Extraescolares',
          abbr: 'ae',
          comentario: '',
          questions: [
            { text: 'El Departamento de Actividades Extraescolares tiene un horario adecuado de atención.', answer: 0 },
            { text: 'Entrega, en tiempo y forma, la constancia de acreditación correspondiente a la actividad complementaria de Actividades Extraescolares ACOM 4.', answer: 0 },
            { text: 'El tiempo de espera para ser atendido es adecuado.', answer: 0 },
            { text: 'Me proporcionan información adecuada y oportuna en caso de que se la solicite, ya sea de forma presencial o en línea.', answer: 0 },
            { text: 'Me atienden en forma amable y respetuosa cuando solicito su apoyo.', answer: 0 },
            { text: 'Llevo la actividad extraescolar que deseo.', answer: 0 },
            { text: 'Los horarios de las Actividades Extraescolares son accesibles.', answer: 0 },
            { text: ' Me dan a conocer los eventos cívicos, torneos y concursos de Actividades Extraescolares, en tiempo y forma.', answer: 0 }
          ]
        },
        {
          name: 'Servicio de Promoción Cultural y Deportiva',
          abbr: 'pcd',
          comentario: '',
          questions: [
            { text: 'El promotor da a conocer las competencias a evaluar, estrategias e instrumentos de evaluación, proyectos formativos e integradores, al inicio del curso.', answer: 0 },
            { text: 'El promotor me brinda la oportunidad y opciones para acreditar la actividad.', answer: 0 },
            { text: 'El promotor me proporciona retroalimentación continua y oportuna del avance en la actividad.', answer: 0 },
            { text: 'El promotor utiliza diversas estrategias, métodos, medios y materiales.', answer: 0 },
            { text: 'El promotor cumple con el programa de estudios presentado al inicio de semestre y se cumple en su totalidad.', answer: 0 },
            { text: 'El promotor explica adecuadamente la utilidad de los contenidos teóricos y prácticos para la actividad.', answer: 0 },
            { text: 'Asiste a clases de manera regular y puntualmente.', answer: 0 },
            { text: 'Considero que tengo un promotor capacitado.', answer: 0 },
            { text: 'Mi nivel de desempeño y aprendizaje logrado fue gracias a la labor del promotor', answer: 0 },
            { text: 'El espacio en el que desarrollo mi Actividad Extraescolar es adecuado', answer: 0 }
          ]
        }
      ]
    }),
    mounted () {
      axios.get('alumno/encuesta-servicios')
        .then(response => {
          this.cargandoDatos = false
          this.encuestado = response.data.encuestado
        })
    },
    methods: {
      clear: function () {
        this.departamentos.map(function (departemento) {
          departemento.questions.map(function (question) {
            question.answer = 0
            return question
          })
        })
        this.e1 = 1
      },
      save: function () {
        axios.post('alumno/encuesta-servicios/guardar', this.departamentos)
          .then(resp => {
            this.encuestado = true
          })
          .catch(error => console.log(error))
      }
    }
  }
</script>

<style scoped>
    @media (max-width: 600px) {
        .v-card__text {
            padding: 0;
        }

        .v-card__text .v-list__tile {
            padding: 0;
            height: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/EncuestaServiciosPage.vue